import React, { Component } from "react";

class Card extends Component {
	state = {
		isOpen: this.props.isOpen ? this.props.isOpen : true
	}

	toggleOpen = () => {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}

	renderHeader = () => {
        if(!this.props.header) {
            return null;
        }
		return (
			<div className={`box-header ${this.props.withoutBorder ? '' : 'with-border'}`}>
				<h3 className="card-title">{this.props.title}</h3>
				<div className="box-tools pull-right">
					<button type="button" className="btn btn-box-tool" onClick={this.toggleOpen}>
						<i className={`fa fa-${this.state.isOpen ? 'minus' : 'plus'}`}></i>
					</button>
              </div>
			</div>
		);
	};

	render() {
		return (
			<div className={`box box-default ${this.state.isOpen ? '' : 'collapsed-box'}`}>
				{this.renderHeader()}
				<div className="box-body">
                    {this.props.children}
                </div>
			</div>
		);
	}
}

export default Card;
